import React from "react"
import { DiJavascript, DiReact } from "react-icons/di";
import { DiNodejs } from "react-icons/di";
import { DiNodejsSmall } from "react-icons/di";
import { DiNpm } from "react-icons/di";
import { SiMui } from "react-icons/si";
import { DiHtml5 } from "react-icons/di";
import { DiCss3 } from "react-icons/di";
import { DiJsBadge } from "react-icons/di";
import { DiNetmagazine } from "react-icons/di";
import { DiJava } from "react-icons/di";
import { DiPython } from "react-icons/di";
import { DiSqllite } from "react-icons/di";
import { DiStreamline } from "react-icons/di";
import { SiTypescript } from "react-icons/si";
import { SiApachekafka } from "react-icons/si";
import { SiGraphql } from "react-icons/si";
import { FaGithub } from "react-icons/fa";


export const SkillSet = [
    {
        name: 'React',
        icon: <DiReact size={32} />
    },
    {
        name: 'Node.js',
        icon: <DiNodejs size={32} />
    },
    {
        name: 'Express',
        icon: <DiNodejsSmall size={32} />
    },
    {
        name: 'Javascript',
        icon: <DiJsBadge size={32} />
    },
    {
        name: 'Typescript',
        icon: <SiTypescript size={32} />
    },
    {
        name: 'Html',
        icon: <DiHtml5 size={32} />
    },
    {
        name: 'Css',
        icon: <DiCss3 size={32} />
    },
    {
        name: 'Material UI',
        icon: <SiMui size={32} />
    },
    {
        name: '.Net',
        icon: <DiNetmagazine size={32} />
    },
    {
        name: 'JAVA',
        icon: <DiJava size={32} />
    },
    {
        name: 'Python',
        icon: <DiPython size={32} />
    },
    {
        name: 'Sql',
        icon: <DiStreamline size={32} />
    },
    {
        name: 'MongoDB',
        icon: <DiSqllite size={32} />
    },
    {
        name: 'Apache Kafka',
        icon: <SiApachekafka size={32} />
    },
    {
        name: 'GraphQl',
        icon: <SiGraphql size={32} />
    },
    {
        name: 'React Native',
        icon: <DiReact size={32} />
    },
    {
        name: 'NPM',
        icon: <DiNpm size={32} />
    },
    {
        name: 'Github workflows',
        icon: <FaGithub size={32} />
    },

]